import type { CSSProperties } from 'react'
import type { AreaChartPoint } from '../AreaChart/AreaChart.types'

export type { AreaChartPoint as SmoothAreaChartPoint }

export const SMOOTH_AREA_CHART_DEFAULT_WIDTH = 680
export const SMOOTH_AREA_CHART_DEFAULT_HEIGHT = 259
export const SMOOTH_AREA_CHART_DEFAULT_STROKE_WIDTH = 2

/** Figma stroke — blue/blue-500. */
export const SMOOTH_AREA_CHART_STROKE_COLOR = 'var(--ds-blue-500)'

/** Figma fill — blue/blue-500 at 10% opacity. */
export const SMOOTH_AREA_CHART_FILL_COLOR = 'var(--ds-blue-500)'
export const SMOOTH_AREA_CHART_FILL_OPACITY = 0.1

/**
 * Default series matching Figma Group 29
 * (y inverted from path coords in a 259px-tall frame).
 */
export const SMOOTH_AREA_CHART_DEFAULT_DATA: AreaChartPoint[] = [
  { value: 31 },
  { value: 104 },
  { value: 76 },
  { value: 208 },
  { value: 259 },
  { value: 156 },
]

export type SmoothAreaChartProps = {
  /** Series values. Defaults to the Figma demo path. */
  data?: AreaChartPoint[]
  /** Chart width in px. Defaults to 680. */
  width?: number
  /** Chart height in px. Defaults to 259. */
  height?: number
  /** Line stroke color. */
  strokeColor?: string
  /** Area fill color. */
  fillColor?: string
  /** Area fill opacity (0–1). Defaults to 0.1. */
  fillOpacity?: number
  /** Line stroke width. Defaults to 2. */
  strokeWidth?: number
  /** Y-axis ceiling. Defaults to the max data value. */
  maxValue?: number
  /** Y-axis floor. Defaults to 0. */
  minValue?: number
  /**
   * Show nearest-point hover tooltip (Dashboard / Reports style).
   * Defaults to `true`.
   */
  showTooltip?: boolean
  /** Series name shown in the tooltip. Defaults to "Value". */
  seriesName?: string
  /** Format tooltip numeric values. Defaults to String(value). */
  formatValue?: (value: number) => string
  /** Dark surface — adjusts tooltip chrome. */
  darkMode?: boolean
  className?: string
  style?: CSSProperties
  'aria-label'?: string
}
